import { Box, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

import { FOUNDRIES } from "../../constants";
import { LogoImage } from "../../svgs";

import { HubHookFormDatePicker } from "../HubHookFormDatePicker";
import { HubHookFormSelect } from "../HubHookFormSelect";
import { FoundryInfo } from "../FoundryInfo";

import PurchaseOrderLabel from "./PurchaseOrderLabel";
import { StyledFobStack, StyledHeaderStack } from "./styles";
import {
  HubHookCustomersSelect,
  HubHookFormInput,
  HubHookFormPartSelectV2,
} from "..";

const today = dayjs().toISOString();

const CompanyInfo = ({ quoteNumber = "Unassigned" }) => {
  const height = 45;

  return (
    <StyledHeaderStack>
      <Stack width="100%">
        <Box
          component="img"
          src={LogoImage}
          height={`${height}px`}
          width={`${height * 2.23}px`}
        />
        <FoundryInfo />
      </Stack>
      <Stack width="100%" justifyContent="center" alignItems="end">
        <PurchaseOrderLabel label="" value="Casting Quote" valueBold />
        <PurchaseOrderLabel label="No." value={quoteNumber} valueBold />
        <HubHookFormDatePicker
          name="createdAt"
          label="QUOTE DATE"
          defaultValue={today}
          shouldUnregister={false}
          formProps={{
            sx: {
              ".MuiFormControl-root": {
                gridTemplateColumns: "1fr !important",
              },
            },
          }}
          disableHelperText
          required
        />
        <HubHookFormSelect
          name="locationId"
          label="LOCATION"
          options={FOUNDRIES}
          required
        />
        <HubHookCustomersSelect
          name="customerId"
          label="CUSTOMER"
          shouldUnregister={false}
          required={false}
          rendered={false}
          className="isLast"
        />
      </Stack>
      <Stack width="100%" justifyContent="center" alignItems="end">
        <HubHookFormPartSelectV2
          name="partId"
          label="PART"
          required={false}
          placeholder={null}
          shouldUnregister={false}
        />
        <HubHookFormInput
          label="NAME"
          name="partName"
          shouldUnregister={false}
          required
        />
        <HubHookFormInput
          label="NUMBER"
          name="partNumber"
          shouldUnregister={false}
          required
        />
        <HubHookFormInput
          name="weight"
          label="WEIGHT"
          shouldUnregister={false}
          endAdornment="lbs"
          isDecimal
          required
        />
        <HubHookFormInput
          label="EAU"
          name="estimatedAnnualUsage"
          shouldUnregister={false}
          startAdornment="$"
          isCurrency
          className="isLast"
        />
      </Stack>
    </StyledHeaderStack>
  );
};

export default CompanyInfo;
